<template>
  <vue-final-modal
    v-slot="{ params, close }"
    v-bind="$attrs"
    :max-height="100"
    classes="modal-container"
    content-class="modal-content"
    @closed="$emit('closed')"
  >
    <h4 v-if="title" class="modal__title">
      <slot name="title"></slot>
    </h4>
    <div class="modal__content">
      <slot :params="params"></slot>
    </div>

    <div v-if="!hideActions" class="modal__action">
      <button :disabled="$attrs.disabled" @click="$emit('confirm', close)">
        {{ confirmText }}
      </button>
      <button v-if="cancelText" :disabled="$attrs.disabled" @click="close">
        {{ cancelText }}
      </button>
    </div>
    <button class="modal__close" @click="close">
      <svg width="1.5em" height="1.5em" viewBox="0 0 14 24">
        <path
          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"
          fill="currentColor"
        ></path>
      </svg>
    </button>
  </vue-final-modal>
</template>

<script>
export default {
  emits: ['closed'],
  props: {
    hideActions: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'No',
    },
    confirmText: {
      type: String,
      default: 'Yes',
    },
    isLoading: {
      type: Boolean,
    },
  },
  setup(props, { slots }) {
    const { title } = slots

    return { title }
  },
}
</script>
